import movingLineMeanings from '../data/movingLineMeanings';

export const getMovingLineMeaning = (hexagramName, lineNumber) => {
  if (!movingLineMeanings[hexagramName] || !movingLineMeanings[hexagramName][lineNumber]) {
    return 'Thông tin chuyên sâu về hào động đang được cập nhật';
  }
  return movingLineMeanings[hexagramName][lineNumber];
};

export const formatPhilosophyContent = (philosophy) => {
  if (!philosophy) return '';
  
  return Object.entries(philosophy)
    .map(([key, value]) => {
      if (typeof value === 'string') {
        return `**${key}**: ${value}`;
      }
      if (Array.isArray(value)) {
        return `**${key}**:\n${value.map(item => `- ${item}`).join('\n')}`;
      }
      return '';
    })
    .filter(Boolean)
    .join('\n\n');
};
